import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { checkForNewItems } from '../../../api/items';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';

export const checkForNewBuzzes = createAsyncThunk(
  'items/checkForNewBuzzes',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await checkForNewItems(
        { path, params },
        {
          cancelToken: source.token,
        },
      );

      const STREAM_RELOAD = 'x-stream-reload';
      return {
        streamReload: response.headers[STREAM_RELOAD] === 'true',
      };
    } catch (error) {
      return rejectWithValue(error.response?.status);
    }
  },
  // {
  //   condition: (thunkData, { getState }) => {
  //     const { scrollPositionItemId } = getState().items;

  //     return !scrollPositionItemId;
  //   },
  // },
);

export const checkForNewBuzzesExtraReducers = {
  [checkForNewBuzzes.pending]: (state, action) => {
    const channelCIDKey = generateChannelCIDKey(action.meta.arg.path);
    checkAndSetLoadingWithId(
      state.items.item.actions.check.request,
      action,
      channelCIDKey,
    );
  },
  [checkForNewBuzzes.fulfilled]: (state, action) => {
    const { payload, meta } = action;
    const channelCIDKey = generateChannelCIDKey(meta.arg.path);

    onMatchedRequest(
      state.items.item.actions.check.request[channelCIDKey],
      action,
      () => {
        state.isShownNewBuzzNotification = payload.streamReload;
      },
    );
  },
  [checkForNewBuzzes.rejected]: (state, action) => {
    const channelCIDKey = generateChannelCIDKey(action.meta.arg.path);
    handleRequestRejection(
      state.items.item.actions.check.request[channelCIDKey],
      action,
    );
  },
};
